import { gql } from "@apollo/client";

export const PRODUCT_DETECTIONS_BY_SEGMENT = gql`
  query productDetections(
    $productIds: [Int]!
    $companyFilters: CompanyFilter!
    $lookbackYears: Int!
    $segment: ProductDetectionSegments!
    $installAge: Int
    $localizeInstalls: Boolean
    $companyMatchFile: CompanyMatchFilter
  ) {
    productDetectionsBySegment(
      productIds: $productIds
      companyFilters: $companyFilters
      localizeInstalls: $localizeInstalls
      lookbackYears: $lookbackYears
      installAge: $installAge
      segment: $segment
      companyMatchFile: $companyMatchFile
    ) {
      productId
      hits
      segment
    }
  }
`;
